import { PpmRepository } from '@/store/ppm-state/ppm-state.repository';
import { DialogObject } from '../../../../components/dialog/dialog.types';

interface getPpmDeleteObjectProps {
  store: PpmRepository;
  representation?: string;
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getPpmDeleteObject = ({ store, representation, action, toggleVisiblity }: getPpmDeleteObjectProps): DialogObject => {
  return {
    title: `Voulez-vous supprimer le plan de passation des marchés ${representation} ?`,
    description: 'Cette action est irréversible',
    onHide() {
      store.reset();
    },
    actions: [
      {
        label: 'Supprimer',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'Annuler',
        onClick: () => toggleVisiblity?.(),
        variant: 'secondary',
      },
    ],
  };
};
